import classNames from "classnames";
import { AppDropdown } from "@/shared/Components/AppDropdown";
import { installationConfig } from "@/shared/constants/installation-config";
import { MessageWithAQuestion } from "@/shared/icons";
import type { FC } from "react";
import styles from "./styles.module.scss";
import { FooterLinks } from "./Components/FooterLinks";

interface Props {
  onClick?: () => void;
}

export const Footer: FC<Props> = () => {
  return (
    <div
      className={classNames(styles.footer, {
        [styles["footer-crescendo"]]: installationConfig.name === "Crescendo",
      })}
    >
      <AppDropdown
        placement="bottomRight"
        trigger={["click"]}
        dropdownRender={() => <FooterLinks />}
        className={styles["dropdown-icon"]}
      >
        <MessageWithAQuestion width={25} height={25} className={styles.icon} />
      </AppDropdown>
    </div>
  );
};
